import { map } from "rxjs/operators";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { AuthService } from "src/app/core/service/auth.service";
import { RestClientService } from "src/app/core/service/rest-client.service";
import { UtilitiesService } from "src/app/core/service/utilities.service";
import Swal from "sweetalert2";
import * as _ from "lodash";
import * as moment from "moment";
import { ModalViewreseauDeSoinDetailComponent } from "src/app/shared/components/modal-view-reseau-soin-detail/modal-view-reseau-soin-detail.component";
import { ModalViewGarantDetailsComponent } from "src/app/shared/components/modal-view-garant-details/modal-view-garant-details.component";

@Component({
  selector: "app-bar-garantie",
  templateUrl: "./bar-garantie.component.html",
  styleUrls: ["./bar-garantie.component.scss"],
})
export class BarGarantieComponent implements OnInit {
  defaultValues: any = {};
  listItems: Array<any> = [];
  items: Array<any> = [];
  itemToSave: any = {};
  @Input() currentProduit: any;
  @Input() currentBareme: any;
  @Output() onChangeGarantieForm = new EventEmitter<any>();
  user: any;
  filiale_id: any;
  gender: string;
  createMessage: string;
  title: string;
  is_all_checked: boolean;
  editMessage: string;
  itemsTypeRemboursement: any = [];
  currentData: any;
  current_produit_id: any;
  indiceTab: number;
  itemToAddTrancheAge: any = {};
  itemsPrimeByTrancheAge: any = [];
  itemToAddStatutTrancheAge: any;
  itemsPrimeByStatutAndTrancheAge: any = [];
  searchKey: any;
  currentPage: number = 0;
  itemsPerPage: number = 30;
  busyGet: Subscription;
  totalItems: any;
  itemsGarantieProduit: any = [];
  itemsChecked: any = [];

  constructor(
    public bsModalRef: BsModalRef,
    private authService: AuthService,
    private restClient: RestClientService,
    private modalService: BsModalService,
    private utilities: UtilitiesService
  ) {
    // this.user = this.authService.currentUserValue;
    this.user = this.authService.getCurrentUser();
    // console.info('user-->: ',this.user)
    this.filiale_id = this.user.filiale_id;
    let text1 = this.gender == "M" ? "un" : "une";
    this.createMessage =
      "Vous êtes sur le point de créer " + text1 + " " + this.title;
    this.editMessage =
      "Vous êtes sur le point de modifier " + text1 + " " + this.title;
    this.itemToSave.plafond_annuel_famille = 0;
    this.itemToSave.prime_par_famille = 0;

    // this.itemToSave.mode_reconduction_id=''

    setTimeout(() => {
      console.log("here");
      // this.itemToSave.date_effet = new Date()
      // this.itemToSave.date_echeance = new Date((new Date()).getFullYear(), 11, 31, 23, 59, 59, 999);
      if (this.currentData) {
        console.log("currentData: ", this.currentData);

        this.itemToSave = Object.assign({}, this.currentData);
        this.current_produit_id = this.itemToSave.id;
        this.getItemsGarantieProduit();
      }
    }, 50);
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("changes in form prime tranche age statut: ", changes);
    this.itemsChecked = []
    const keysToClear = ["type_remboursement_id", "plafond_famille", "plafond_individuel", "is_checked"];

    this.items.forEach(item => {
      keysToClear.forEach(key => item[key] = null); // Set to null
    });
    if (
      changes && changes.currentBareme &&
      changes.currentBareme.currentValue && changes.currentBareme.currentValue.id &&
      changes.currentProduit && changes.currentProduit.currentValue
    ) {
      this.getItemsGarantieProduitBareme();

    }
    else {
      this.getItemsGarantieProduit();

    }
  }
  // ngOnChanges(changes: SimpleChanges) {
  //   console.log("changes: ",changes)
  //   if (changes && changes.currentBareme?.currentValue &&  changes.currentProduit.currentValue) {
  //     //si on est en mode modification de bareme
  //     this.itemToSave.mode_tarification_id = this.currentProduit.mode_tarification_id
  //     this.check_if_is_famille()
  //     if(changes.currentBareme?.currentValue.id)
  //       this.getItemsProduitBaremeStatutConfig()
  //     else
  //       this.getItemsPlafondConfigStatut()
  //   }

  // }

  selectedChangeValue(event: any) {
    console.log("le event selectedChangeValue", event);

    if (!event) this.indiceTab = 0;

    this.indiceTab = event;
  }

  resetForm() {
    this.itemToSave.typeActeId = null;
    this.itemToSave.libelle = "";
    this.itemToAddTrancheAge.age_min = 0;
    if (this.itemsPrimeByTrancheAge && this.itemsPrimeByTrancheAge > 0) {
      this.itemToAddTrancheAge.age_min =
        Math.min(...this.itemsPrimeByTrancheAge.map((r) => r.age_max)) + 1;
    }

    this.itemToAddStatutTrancheAge.age_min = 0;
    if (
      this.itemsPrimeByStatutAndTrancheAge &&
      this.itemsPrimeByStatutAndTrancheAge > 0
    ) {
      this.itemToAddStatutTrancheAge.age_min =
        Math.min(
          ...this.itemsPrimeByStatutAndTrancheAge.map((r) => r.age_max)
        ) + 1;
    }
    // this.itemtad
  }

  getItems() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      search_key: this.searchKey,
      data: {},
      index: this.currentPage,
      size: this.itemsPerPage,
    };

    this.busyGet = this.restClient
      .post("garantie/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"] && !res["hasError"]) {
            this.items = res["items"];
            
            console.log("this.itemsChecked before update: ", this.itemsChecked);
            // debugger
            this.fillForm();
            if (this.currentBareme.id && this.currentProduit.id)
              this.getItemsGarantieProduitBareme()
            // this.setDefautValuesGarantie();

            console.log("items transform: ", this.items);
            // console.log('items transform: ',JSON.stringify(this.items))
            this.totalItems = res["count"];
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.items = [];
            this.totalItems = 0;
          }
        },
        (err) => { }
      );
  }

  fillForm() {
    console.log("this.itemsChecked: ", this.itemsChecked)
    if (this.itemsChecked && this.itemsChecked.length) {
      this.items.map((it) => {
        // it.is_checked = this.itemsChecked.filter(it2=>it2.id ==it.id ).length ?1:0
        it.is_checked = this.itemsChecked.filter((it2) =>
          it2.garantie_id ? it2.garantie_id == it.id : it2.id == it.id
        ).length
          ? true
          : false;
        this.itemsChecked.map((ic) => {
          console.log("ic.plafond_famille: ", ic.plafond_famille)
          // it.plafond_police = ic.plafond_police;
          // it.plafond_college = ic.plafond_college;
          if (ic.garantie_id == it.id) {
            it.plafond_police = ic.plafond_police;
            it.plafond_college = ic.plafond_college;
            it.plafond_famille = ic.plafond_famille;
            it.plafond_individuel = ic.plafond_individuel;
            it.type_remboursement_id = ic.type_remboursement_id;
          }

        });
        // it.is_checked = true
      });

      console.log("this.items transformed: ", this.items)
    }
    this.onInputChange();
  }
  getItemsGarantieProduit() {
    if (!this.currentProduit) {
      return;
    }
    if (this.currentBareme.id) {
      return;
    }
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      data: {
        produit_id: this.currentProduit.id,
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("garantieProduit/getByCriteria", request)
      .subscribe(
        (res) => {
          // this.getItems();
          if (res && res["items"] && !res["hasError"]) {
            this.itemsGarantieProduit = res["items"];
            this.itemsChecked = this.itemsGarantieProduit;
            this.onInputChange()
            this.fillForm();
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsGarantieProduit = [];
          }
        },
        (err) => {
          this.itemsGarantieProduit = [];
        }
      );
  }
  getItemsGarantieProduitBareme() {
    // debugger
    this.itemsChecked = []
    let request = {
      user_id: this.user.id,
      filiale_id: this.filiale_id || this.user.filiale_id,
      data: {
        bareme_id: this.currentBareme.id,
        produit_bareme_id: this.currentProduit.id,
      },
      index: 0,
      size: 10000,
    };

    this.busyGet = this.restClient
      .post("garantieProduitBareme/getByCriteria", request)
      .subscribe(
        (res) => {
          // this.getItems();
          if (res && res["items"] && !res["hasError"]) {
            this.itemsGarantieProduit = res["items"];
            this.itemsChecked = this.itemsGarantieProduit;
            this.fillForm();
          } else {
            this.utilities.showNotification(
              "snackbar-danger",
              this.utilities.formatMsgServeur(res["status"]["message"]),
              "bottom",
              "center"
            );
            this.itemsGarantieProduit = [];
          }
        },
        (err) => {
          this.itemsGarantieProduit = [];
        }
      );
  }

  setDefautValuesGarantie() {
    if (this.items && this.items.length) {
      this.items.map((it) => {
        if (
          this.defaultValues.type_remboursement_id &&
          !it.type_remboursement_id
        )
          it.type_remboursement_id = this.defaultValues.type_remboursement_id;
        if (this.defaultValues.plafond_police && !it.plafond_police)
          it.plafond_police = this.defaultValues.plafond_police;
        if (this.defaultValues.plafond_college && !it.plafond_college)
          it.plafond_college = this.defaultValues.plafond_college;
        if (this.defaultValues.plafond_famille && !it.plafond_famille)
          it.plafond_famille = this.defaultValues.plafond_famille;
        if (this.defaultValues.plafond_individuel && !it.plafond_individuel)
          it.plafond_individuel = this.defaultValues.plafond_individuel;
      });
    }
    this.onInputChange();
  }

  onSelectAllRow(event) {
    // if (this.items && this.items.length) {
    //   const isChecked = event.target.checked;

    //   // Update each item's is_checked property
    //   this.items.forEach((item) => (item.is_checked = isChecked));

    //   if (isChecked) {
    //     // Add all items to itemsChecked, avoiding duplicates
    //     this.items.forEach((item) => {
    //       if (
    //         !this.itemsChecked.some((checkedItem) => checkedItem.id === item.id)
    //       ) {
    //         this.itemsChecked.push(item);
    //       }
    //     });
    //   } else {
    //     // Remove all items from itemsChecked
    //     const uncheckedIds = this.items.map((item) => item.id);
    //     this.itemsChecked = this.itemsChecked.filter(
    //       (checkedItem) => !uncheckedIds.includes(checkedItem.id)
    //     );
    //   }
    // }
    const isChecked = event.target.checked;

    // Update each item's is_checked property
    this.items.forEach((item) => (item.is_checked = isChecked));
    this.onInputChange();
  }

  customSortTypeRembCodification(a, b) {
    const desiredOrder = ["TPRD", "TP", "RD", "TPG"];
    return (
      desiredOrder.indexOf(a.codification) -
      desiredOrder.indexOf(b.codification)
    );
  }

  getItemsTypeRemboursement() {
    let request = {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: {},
    };

    this.busyGet = this.restClient
      .post("typeRemboursement/getByCriteria", request)
      .subscribe(
        (res) => {
          if (res && res["items"]) {
            this.itemsTypeRemboursement = _.orderBy(
              res["items"],
              ["libelle"],
              ["asc"]
            );

            this.itemsTypeRemboursement.sort((a, b) =>
              this.customSortTypeRembCodification(a, b)
            );
            // this.defaultValues.type_remboursement_id = this.itemsTypeRemboursement.filter(itr=>itr.codification=='TPRD')[0].id
          } else {
            this.itemsTypeRemboursement = [];
          }
        },
        (err) => {
          this.itemsTypeRemboursement = [];
        }
      );
  }

  onInputChange() {
    // if(!this.currentBareme.id){
    //   this.onChangeGarantieForm.emit(this.itemsChecked);

    // }
    // else{
    //   let itemsElligible = this.items.filter(it=>it.is_checked)
    //   if(itemsElligible.length > 0){
    //     itemsElligible.map(ie=>{
    //       ie.garantie_libelle = ie.libelle
    //       ie.garantie_id = ie.id
    //       // delete ie.id
    //     })
    //   }

    //   this.onChangeGarantieForm.emit(itemsElligible);
    // }
    this.items.forEach((item) => (item.is_checked = true));

    let itemsElligible = this.items.filter(it => it.is_checked)
    if (itemsElligible.length > 0) {
      itemsElligible.map(ie => {
        ie.garantie_libelle = ie.libelle
        ie.garantie_id = ie.id
        // delete ie.id
      })
    }

    this.onChangeGarantieForm.emit(itemsElligible);
  }
  onSelectRow(item, event) {
    // if(!this.currentBareme.id){
    //   if (event.target.checked) {
    //     // this.itemsChecked = this.items.filter(it=>it.is_checked)
    //     this.itemsChecked.push({ ...item });
    //   } else {
    //     this.itemsChecked = this.itemsChecked.filter((it) => it.id !== item.id);
    //   }
    // }

    this.onInputChange();
  }

  ngOnInit() {
    this.getItems();
    this.getItemsTypeRemboursement();
  }
}
